<div class="profile__wrapper">
  <form [formGroup]="form">
    <fieldset [disabled]="!isEditable" class="form__fieldset">
      <div class="row">
        <div class="col-6">
          <div class="row mb-3 profile__item">
            <label class="label-input col-sm-4">Identity tax number</label>
            <div class="col-sm-3 profile__validation">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="taxNumber"
              />
            </div>
          </div>
          <div class="row mb-3 profile__item">
            <label class="label-input col-sm-4">Description number (МЮУ)</label>
            <div class="col-sm-3 profile__validation">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="descriptionNumber"
              />
            </div>
          </div>
          <div class="row mb-3 profile__item">
            <label class="label-input col-sm-4">Date registration PE</label>
            <div class="col-sm-3 profile__validation">
              <div
                [class.custom-input-empty]="
                  isEditable && !form.controls['peRegistrationDate'].value
                "
                [class.custom-input-filled]="
                  isEditable && form.controls['peRegistrationDate'].value
                "
                [class.pl-8]="isEditable"
                [class.read-mode]="!isEditable"
              >
                <app-datepicker
                  [iconLeft]="true"
                  [fontSize]="14"
                  formControlName="peRegistrationDate"
                  [showIcon]="isEditable"
                ></app-datepicker>
              </div>
            </div>
          </div>
          <div class="row mb-3 profile__item">
            <label class="label-input col-sm-4">Address registration</label>
            <div class="col-sm-3 profile__validation">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="addressRegistration"
              />
            </div>
          </div>
          <div class="row mb-3 profile__item">
            <label class="label-input col-sm-4">Адреса реєстрації</label>
            <div class="col-sm-3 profile__validation">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="addressRegistrationUA"
              />
            </div>
          </div>
          <div class="row mb-3 profile__item">
            <label class="label-input col-sm-4"
              >Date of registration by the taxpayer</label
            >
            <div class="col-sm-3 profile__validation">
              <div
                [class.custom-input-empty]="
                  isEditable &&
                  !form.controls['registrationDateByTaxpayer'].value
                "
                [class.custom-input-filled]="
                  isEditable &&
                  form.controls['registrationDateByTaxpayer'].value
                "
                [class.pl-8]="isEditable"
                [class.read-mode]="!isEditable"
              >
                <app-datepicker
                  [iconLeft]="true"
                  [fontSize]="14"
                  formControlName="registrationDateByTaxpayer"
                  [showIcon]="isEditable"
                ></app-datepicker>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row mb-3 profile__item">
            <label class="label-input col-sm-3">Key name (ЕЦП)</label>
            <div class="col-sm-3 profile__validation">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="keyName"
              />
            </div>
          </div>
          <div class="row mb-3 profile__item">
            <label class="label-input col-sm-3">Key (ЕЦП)</label>
            <div class="col-sm-3 profile__validation">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="key"
              />
            </div>
          </div>
          <div class="row mb-3 profile__item">
            <label class="label-input col-sm-3">Key's Date end (ЕЦП) </label>
            <div class="col-sm-3 profile__validation">
              <div
                [class.custom-input-empty]="
                  isEditable && !form.controls['keysDateEnd'].value
                "
                [class.custom-input-filled]="
                  isEditable && form.controls['keysDateEnd'].value
                "
                [class.pl-8]="isEditable"
                [class.read-mode]="!isEditable"
              >
                <app-datepicker
                  [iconLeft]="true"
                  [fontSize]="14"
                  formControlName="keysDateEnd"
                  [showIcon]="isEditable"
                ></app-datepicker>
              </div>
            </div>
          </div>
          <div class="row mb-3 profile__item">
            <label class="label-input col-sm-3">Password to the key</label>
            <div class="col-sm-3 profile__validation">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="keyPassword"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="table">
        <div class="table__col">
          <div class="table__header">Taxes information</div>
          <div class="table__inner-col">
            <div class="table__labels">
              <div class="table__label">
                <label class="label-input">Who makes the reports</label>
              </div>
              <div class="table__label">
                <label class="label-input">Who pays taxes</label>
              </div>
              <div class="table__label">
                <label class="label-input">Date of tax payment (ЄП)</label>
              </div>
              <div class="table__label">
                <label class="label-input">Date of tax payment (ЄСВ)</label>
              </div>
              <div class="table__label">
                <label class="label-input">Date of last tax report (ЄП)</label>
              </div>
              <div class="table__label">
                <label class="label-input">Date of last tax report (ЄСВ)</label>
              </div>
              <div class="table__label">
                <label class="label-input">20 ОПП report</label>
              </div>
            </div>
            <div class="table__values">
              <div class="table__dropdown">
                <app-dropdown
                  [border]="isEditable ? 'classic' : 'none'"
                  [isEditMode]="isEditable"
                  formControlName="whoMakesReports"
                  [items]="whoMakesTheReportDropdown"
                ></app-dropdown>
              </div>
              <div class="table__dropdown">
                <app-dropdown
                  [border]="isEditable ? 'classic' : 'none'"
                  [isEditMode]="isEditable"
                  formControlName="whoPaysTaxes"
                  [items]="whoPaysTaxesDropdown"
                ></app-dropdown>
              </div>
              <div
                [class.custom-input-empty]="
                  isEditable && !form.controls['stTaxPaymentDate'].value
                "
                [class.custom-input-filled]="
                  isEditable && form.controls['stTaxPaymentDate'].value
                "
                [class.pl-8]="isEditable"
                [class.read-mode]="!isEditable"
                class="table__datepicker"
              >
                <app-datepicker
                  [iconLeft]="true"
                  [fontSize]="14"
                  formControlName="stTaxPaymentDate"
                  [showIcon]="isEditable"
                ></app-datepicker>
              </div>
              <div
                [class.custom-input-empty]="
                  isEditable && !form.controls['sstTaxPaymentDate'].value
                "
                [class.custom-input-filled]="
                  isEditable && form.controls['sstTaxPaymentDate'].value
                "
                [class.pl-8]="isEditable"
                [class.read-mode]="!isEditable"
                class="table__datepicker"
              >
                <app-datepicker
                  [iconLeft]="true"
                  [fontSize]="14"
                  formControlName="sstTaxPaymentDate"
                  [showIcon]="isEditable"
                ></app-datepicker>
              </div>

              <div
                [class.custom-input-empty]="
                  isEditable && !form.controls['stTaxPaymentLastDate'].value
                "
                [class.custom-input-filled]="
                  isEditable && form.controls['stTaxPaymentLastDate'].value
                "
                [class.pl-8]="isEditable"
                [class.read-mode]="!isEditable"
                class="table__datepicker"
              >
                <app-datepicker
                  [iconLeft]="true"
                  [fontSize]="14"
                  formControlName="stTaxPaymentLastDate"
                  [showIcon]="isEditable"
                ></app-datepicker>
              </div>
              <div
                [class.custom-input-empty]="
                  isEditable && !form.controls['sstTaxPaymentLastDate'].value
                "
                [class.custom-input-filled]="
                  isEditable && form.controls['sstTaxPaymentLastDate'].value
                "
                [class.pl-8]="isEditable"
                [class.read-mode]="!isEditable"
                class="table__datepicker"
              >
                <app-datepicker
                  [iconLeft]="true"
                  [fontSize]="14"
                  formControlName="sstTaxPaymentLastDate"
                  [showIcon]="isEditable"
                ></app-datepicker>
              </div>
              <div class="table__dropdown">
                <app-dropdown
                  [border]="isEditable ? 'classic' : 'none'"
                  [isEditMode]="isEditable"
                  formControlName="report"
                  [items]="agreementDropdown"
                ></app-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="table__comment">
          <div class="table__header">Comment</div>
          <div class="table__item">
            <input
              type="text"
              class="input__basic table__input"
              placeholder=" "
              formControlName="whoMakesReportsComment"
            />
          </div>
          <div class="table__item">
            <input
              type="text"
              class="input__basic table__input"
              placeholder=" "
              formControlName="whoPaysTaxesComment"
            />
          </div>
          <div class="table__item">
            <input
              type="text"
              class="input__basic table__input"
              placeholder=" "
              formControlName="stTaxPaymentDateComment"
            />
          </div>
          <div class="table__item">
            <input
              type="text"
              class="input__basic table__input"
              placeholder=" "
              formControlName="sstTaxPaymentDateComment"
            />
          </div>
          <div class="table__item">
            <input
              type="text"
              class="input__basic table__input"
              placeholder=" "
              formControlName="stTaxPaymentLastDateComment"
            />
          </div>
          <div class="table__item">
            <input
              type="text"
              class="input__basic table__input"
              placeholder=" "
              formControlName="sstTaxPaymentLastDateComment"
            />
          </div>
          <div class="table__item">
            <input
              type="text"
              class="input__basic table__input"
              placeholder=" "
              formControlName="reportComment"
            />
          </div>
        </div>
      </div>
    </fieldset>
  </form>
  <i
    class="icon-pencil"
    *ngIf="ableToEdit"
    (click)="switchEdit()"
    [class.grey]="isEditable"
  ></i>
  <button
    class="button button__save profile__button"
    *ngIf="isEditable"
    #saveButton
    (click)="saveChanges()"
  >
    Save
  </button>
</div>
